import en from './strings.en';

const ru = {
    chooseLists: 'Выберите списки',
    listDescription: 'Информация о списках доступна только вам и сотрудникам вашей компании.',
    searchPlaceholder: 'поиск по названиям списков',
    createList: 'Создать новый список',
    save: 'Сохранить',
    saved: 'Сохранено'
};

export default { ru, en: { ...ru, ...en} };
